import { SetupOnboarding } from 'views/setup/onboarding';
import { NotFound } from 'views/error/404';

const Routes = [
  {
    path: '/setup',
    view: NotFound,             // SetupOnboarding,
    layout: 'auth',              //'onboarding',
    title: 'TRS Administrador'
  },
]

export default Routes;